// extracted by mini-css-extract-plugin
module.exports = {"item":"tHcZaAYA"};